import { getApiBaseUrl } from '@/lib/config'
import type { PublicSiteConfig } from '@/lib/public-site-config'

let cached: PublicSiteConfig | null = null
let expiresAt = 0
let pending: Promise<PublicSiteConfig> | null = null

/** Unlike the general config getter, an outage must not look like an explicit disable. */
export function getOfferwallSettings(force = false): Promise<PublicSiteConfig> {
  if (pending) return pending
  if (!force && cached && expiresAt > Date.now()) return Promise.resolve(cached)
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 10_000)
  pending = (async () => {
    const response = await fetch(`${getApiBaseUrl()}/api/settings/public`, {
      cache: 'no-store',
      signal: controller.signal,
    })
    if (!response.ok) throw new Error('Reklam ayarları yüklenemedi')
    const data = await response.json() as Partial<PublicSiteConfig>
    if (!data || data.offerwall_enabled == null || data.ads_enabled == null) {
      throw new Error('Reklam ayarları geçersiz')
    }
    cached = {
      ...data,
      offerwall_provider: data.offerwall_provider || 'gam_rewarded',
      offerwall_enabled: String(data.offerwall_enabled),
      ads_enabled: String(data.ads_enabled),
      adsense_client: String(data.adsense_client || ''),
    } as PublicSiteConfig
    expiresAt = Date.now() + 30_000
    return cached
  })().finally(() => {
    clearTimeout(timer)
    pending = null
  })
  return pending
}
